import client from './client';

export const getPublicWildfires = (params) =>
  client.get('/public/wildfires', { params }).then((r) => r.data);

export const getPublicTenants = () =>
  client.get('/public/tenants').then((r) => r.data);

// Distinct fire-season tags that have public fires, plus today's season tag.
// Drives the public map's season picker (defaults to the latest season).
export const getPublicSeasons = (params) =>
  client.get('/public/seasons', { params }).then((r) => r.data);

export const getPublicImages = (params) =>
  client.get('/public/images', { params }).then((r) => r.data);

export const getPublicStatsSummary = () =>
  client.get('/public/stats/summary').then((r) => r.data);

export const getForecast = (params) =>
  client.get('/public/forecast', { params }).then((r) => r.data);
